export default "__VITE_ASSET__DsI9OTzw__"